import React from 'react';
import { Section } from './ui/Section';
import { Countdown } from './ui/Countdown';
export function CostComparison() {
  return <Section data-id="element-94">
      <div className="text-center mb-12" data-id="element-95">
        <h2 className="font-display text-3xl md:text-5xl font-bold mb-6 text-brand-title" data-id="element-96">
          🧴 EL AUDITOR DE SKINCARE™
        </h2>
        <p className="font-body text-xl text-brand-text max-w-2xl mx-auto mb-4" data-id="element-97">
          La próxima semana puedes seguir probando productos a ciegas y gastando
          dinero en lo que no funciona.
        </p>
        <p className="font-heading text-xl text-brand-cta font-bold max-w-2xl mx-auto mb-12" data-id="element-98">
          O puedes tener tu piel resuelta desde hoy.
        </p>

        <div className="mb-10" data-id="element-99">
          <h3 className="font-heading text-lg font-bold text-brand-subtitle mb-4" data-id="element-100">
            ⏰ El precio de lanzamiento cierra en:
          </h3>
          <Countdown data-id="element-101" />
          <p className="font-body text-brand-text mt-4 text-sm" data-id="element-102">
            Después sube el precio y no vuelve.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto space-y-6" data-id="element-103">
        {/* Complete Offer - Featured */}
        <div className="bg-white border-2 border-brand-gold rounded-3xl p-8 text-center shadow-[0_10px_40px_rgba(201,168,76,0.15)] relative" data-id="element-104">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-gold text-white font-heading font-bold px-4 py-1 rounded-full text-sm whitespace-nowrap shadow-sm" data-id="element-105">
            ⭐ LA MÁS ELEGIDA
          </div>
          <h3 className="font-heading text-2xl font-bold text-brand-title mb-2" data-id="element-106">
            🏆 PACK COMPLETO + PIEL SIN FILTROS™
          </h3>
          <p className="font-body text-brand-subtitle mb-6" data-id="element-107">
            5 Tomos + 3 Bonos + Sistema de Alta Potencia
          </p>
          <div className="font-heading text-5xl font-black text-brand-title mb-8" data-id="element-108">
            19.99€
          </div>
          <a href="https://pagos.digipromarket.com/cart/56484211622214:1" target="_blank" rel="noopener noreferrer" className="font-heading w-full md:w-auto inline-block bg-brand-cta hover:bg-brand-ctaHover text-white font-bold text-lg py-4 px-10 rounded-xl transition-transform hover:scale-[1.02] active:scale-[0.98] shadow-md" data-id="element-109">
            → SÍ, QUIERO PIEL SIN FILTROS™ + TODO EL SISTEMA
          </a>
        </div>

        {/* Base Offer */}
        <div className="bg-white border border-neutral-200 rounded-3xl p-8 text-center shadow-sm" data-id="element-110">
          <h3 className="font-heading text-xl font-bold text-brand-title mb-2" data-id="element-111">
            📘 OFERTA BASE
          </h3>
          <p className="font-body text-brand-subtitle mb-6" data-id="element-112">
            5 Tomos + 3 Bonos
          </p>
          <div className="font-heading text-4xl font-black text-brand-title mb-6" data-id="element-113">
            13.99€
          </div>
          <a href="https://pagos.digipromarket.com/cart/56484209328454:1" target="_blank" rel="noopener noreferrer" className="font-heading w-full md:w-auto inline-block bg-white border-2 border-brand-cta text-brand-cta hover:bg-brand-bgAlt font-bold text-lg py-3 px-10 rounded-xl transition-colors" data-id="element-114">
            → QUIERO MI AUDITOR DE SKINCARE™
          </a>
        </div>
      </div>
    </Section>;
}